<template>
<div>

    <v-container class="fill-height" fluid>
        <v-tabs v-model="tab">
            <v-tabs-slider></v-tabs-slider>
            <v-tab :href="`#tab-${index}`" class="text-capitalize" :key="index" v-for="(tab,index) in tabs">{{tab.name}}</v-tab>
            <v-tab-item :key="index" :value="`tab-${index}`" v-for="(tab,index) in tabs">
                <component :is="tab.component"/>
            </v-tab-item>
        </v-tabs>
    </v-container>

</div>
</template>

<script>
import DashboardBanners from "./DashboardBanners";
import HighlightBanners from "./HighlightBanners";
import OCBanners from "./OCBanners";
export default {
    name: "Banners",
    components: {DashboardBanners, HighlightBanners, OCBanners},
    data () {
        return {
            tab: 'tab-0',
            tabs: [
                { name: 'Banners', component: DashboardBanners },
                { name: 'Highlights', component: HighlightBanners },
                { name: 'Banner at Order Confirmation', component: OCBanners },
            ]
        }
    },
}
</script>

<style scoped>

</style>